<template>
  <div class="topEnter">
    <div class="enter1">
      <div class="enter1__triangle" v-show="viewState > 1">
        <img src="@/assets/top/enter-tri.svg" alt="" />
      </div>

      <transition name="fx">
      <div v-show="viewState == 1">
        <div class="enter1__spacer"></div>
        <div class="enter1__text enter1__text--top1">
          アーティストにメッセージを届けよう！
        </div>
        <div class="enter1__text2">
          本サービス利用にあたり<a :href="terms" target="_blank">利用規約</a>に同意するものとします。
        </div>
        <div @click="enter" class="enterButton">
          <img src="@/assets/top/btn/btn-enter.png" alt="" />
        </div>
        <!--<div @click="enter" class="buttonPrimary topEnterButton">
          <img src="@/assets/top/enter-text.png" alt="">
        </div>-->
      </div>
      </transition>

      <transition name="fx">

      <div v-show="viewState == 2">
        <div class="enter1__text">
          続きからメッセージを描く方はこちらから
        </div>
        <div @click="resume" class="enterButton">
          <img src="@/assets/top/btn/btn-enter.png" alt="" />
        </div>
        <div class="enter1__text enter1__text--resume">
          描き直す方はこちらから
        </div>
        <div @click="enter" class="button topEnterMiniButton">
          <img src="@/assets/top/enter-mini.png" alt="" />
        </div>
      </div>
      </transition>
      <transition name="fx">

      <div v-show="viewState == 3">
        <div class="enter1__text">メッセージの投稿は終了しました</div>
        <div class="enterButton enterButton--disable">
          <img src="@/assets/top/btn/btn-enter-disabled.png" alt="" />
        </div>
      </div>
      </transition>
      <transition name="fx">

      <div v-show="viewState == 4">
        <div class="enter1__text">自分が残したメッセージはこちらから</div>
        <div @click="gotoEnd" class="enterButton">
          <img src="@/assets/top/btn/btn-enter.png" alt="" />
        </div>
      </div>
      </transition>
    </div>
  </div>
</template>

<script>
import * as StoreUtil from "../../../util/StoreUtil";
import { terms } from "../../../data/Links";

export default {
  name: "TopEnter",
  props: ["viewState"],
  computed: {
    terms() {
      return terms;
    }
  },
  methods: {
    enter() {
      StoreUtil.gotoArea();
    },
    resume() {
      this.$emit("resume");
    },
    gotoEnd() {
      this.$emit("gotoEnd");
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../../sass/common"
.buttonPrimary, .button
  margin: auto
.enterButton
  animation: cubic-bezier(.92,.04,.99,-0.17) enterAnim 1.12s infinite alternate
  &.enterButton--disable
    animation: none
    img:active
      opacity: 1
  img
    width: 72%
    &:active
      opacity: 0.5
.topEnterButton
  width: 270px
  height: 64px
  img
    width: 91px
.topEnterMiniButton
  width: 215px
  height: 50px
  img
    width: 72px
.topEnter
  text-align: center
  .enter1__triangle
    img
      margin: 13px auto
      display: block
      width: 19px
  .enter1__spacer
    padding-top: 8px
  .enter1__text
    margin-bottom: .7em
    @include vw(14)
    @include bold
    a
      text-decoration: underline
  .enter1__text--top1
    @include vw2(29)
    line-height: 1em
    margin-top: 0.2em
    margin-bottom: 0.1em
  .enter1__text--resume
    margin-top: 40px
  .enter1__text2
    @include vw2(23)
    margin-bottom: 2em
@keyframes enterAnim
  0%
    filter: brightness(1)
  100%
    filter: brightness(5.5)

.fx-enter-active, .fx-leave-active
  transition: all .3s ease-in-out

.fx-enter
  opacity: 1.0

.fx-enter, .fx-leave-to
  opacity: 0


</style>
